import axios from '../utils/axios';
import moment from 'moment';

export default function submitBulkJobUpload(adminId, formData) {

    console.log('submitBulkJobUpload', formData);
    return axios.post(`/admin/${adminId}/bulk-job-upload`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}